{
  "errors": {
    "failedToLoadInventoryLedger": "Failed to load inventory ledger"
  },
  "pages": {
    "inventoryLedger": "Inventory Ledger",
    "immutableMovementLogSourceOfTruth": "Immutable movement log — source of truth for all quantity changes"
  },
  "labels": {}
}
